import { Reducer } from 'redux';
import { OnboardingActionTypes, OnboardingState } from './types';

export const initialState: OnboardingState = {
  saveUserProfileResponse: undefined,
  isSavingUserProfile: false,
  saveUserProfileError: undefined,
  requestUserLinkingResponse: undefined,
  isRequestingUserLinking: false,
  requestUserLinkingError: undefined,
  verifyUserLinkingResponse: undefined,
  isVerifyingUserLinking: false,
  verifyUserLinkingError: undefined,
  confirmUserLinkingResponse: undefined,
  isConfirmingUserLinking: false,
  confirmUserLinkingError: undefined,
  setEmailLinkingResponse: undefined,
  isSetEmailLinking: false,
  setEmailLinkingError: undefined,
  importEnquiriesResponse: undefined,
  isImportingEnquiries: false,
  importEnquiriesError: undefined,
  fetchImportEnquiriesStatus: undefined,
  isFetchingImportEnquiriesStatus: false
};

const reducer: Reducer<OnboardingState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case OnboardingActionTypes.SAVE_USER_PROFILE_START: {
      return {
        ...state,
        saveUserProfileResponse: undefined,
        isSavingUserProfile: true,
        saveUserProfileError: undefined
      };
    }
    case OnboardingActionTypes.SAVE_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        saveUserProfileResponse: action.payload,
        isSavingUserProfile: false,
        saveUserProfileError: undefined
      };
    }
    case OnboardingActionTypes.SAVE_USER_PROFILE_FAILURE: {
      return {
        ...state,
        saveUserProfileResponse: undefined,
        isSavingUserProfile: false,
        saveUserProfileError: action.payload
      };
    }
    case OnboardingActionTypes.REQUEST_USER_LINKING_START: {
      return {
        ...state,
        requestUserLinkingResponse: undefined,
        isRequestingUserLinking: true,
        requestUserLinkingError: undefined
      };
    }
    case OnboardingActionTypes.REQUEST_USER_LINKING_SUCCESS: {
      return {
        ...state,
        requestUserLinkingResponse: action.payload,
        isRequestingUserLinking: false,
        requestUserLinkingError: undefined
      };
    }
    case OnboardingActionTypes.REQUEST_USER_LINKING_FAILURE: {
      return {
        ...state,
        requestUserLinkingResponse: undefined,
        isRequestingUserLinking: false,
        requestUserLinkingError: action.payload
      };
    }
    case OnboardingActionTypes.VERIFY_USER_LINKING_START: {
      return {
        ...state,
        verifyUserLinkingResponse: undefined,
        isVerifyingUserLinking: true,
        verifyUserLinkingError: undefined
      };
    }
    case OnboardingActionTypes.VERIFY_USER_LINKING_SUCCESS: {
      return {
        ...state,
        verifyUserLinkingResponse: action.payload,
        isVerifyingUserLinking: false,
        verifyUserLinkingError: undefined
      };
    }
    case OnboardingActionTypes.VERIFY_USER_LINKING_FAILURE: {
      return {
        ...state,
        verifyUserLinkingResponse: undefined,
        isVerifyingUserLinking: false,
        verifyUserLinkingError: action.payload
      };
    }
    case OnboardingActionTypes.CONFIRM_USER_LINKING_START: {
      return {
        ...state,
        confirmUserLinkingResponse: undefined,
        isConfirmingUserLinking: true,
        confirmUserLinkingError: undefined
      };
    }
    case OnboardingActionTypes.CONFIRM_USER_LINKING_SUCCESS: {
      return {
        ...state,
        confirmUserLinkingResponse: action.payload,
        isConfirmingUserLinking: false,
        confirmUserLinkingError: undefined
      };
    }
    case OnboardingActionTypes.CONFIRM_USER_LINKING_FAILURE: {
      return {
        ...state,
        confirmUserLinkingResponse: undefined,
        isConfirmingUserLinking: false,
        confirmUserLinkingError: action.payload
      };
    }
    case OnboardingActionTypes.SET_EMAIL_LINKING_START: {
      return {
        ...state,
        setEmailLinkingResponse: undefined,
        isSetEmailLinking: true,
        setEmailLinkingError: undefined
      };
    }
    case OnboardingActionTypes.SET_EMAIL_LINKING_SUCCESS: {
      return {
        ...state,
        setEmailLinkingResponse: action.payload,
        isSetEmailLinking: false,
        setEmailLinkingError: undefined
      };
    }
    case OnboardingActionTypes.SET_EMAIL_LINKING_FAILURE: {
      return {
        ...state,
        setEmailLinkingResponse: undefined,
        isSetEmailLinking: false,
        setEmailLinkingError: action.payload
      };
    }
    case OnboardingActionTypes.IMPORT_ENQUIRIES_START: {
      return {
        ...state,
        importEnquiriesResponse: undefined,
        isImportingEnquiries: true,
        importEnquiriesError: undefined
      };
    }
    case OnboardingActionTypes.IMPORT_ENQUIRIES_SUCCESS: {
      return {
        ...state,
        importEnquiriesResponse: action.payload,
        isImportingEnquiries: false,
        importEnquiriesError: undefined
      };
    }
    case OnboardingActionTypes.IMPORT_ENQUIRIES_FAILURE: {
      return {
        ...state,
        importEnquiriesResponse: undefined,
        isImportingEnquiries: false,
        importEnquiriesError: action.payload
      };
    }
    case OnboardingActionTypes.FETCH_IMPORT_ENQUIRIES_STATUS_START: {
      return {
        ...state,
        isFetchingImportEnquiriesStatus: true
      };
    }
    case OnboardingActionTypes.FETCH_IMPORT_ENQUIRIES_STATUS_SUCCESS: {
      return {
        ...state,
        fetchImportEnquiriesStatus: action.payload,
        isFetchingImportEnquiriesStatus: false
      };
    }
    case OnboardingActionTypes.FETCH_IMPORT_ENQUIRIES_STATUS_FAILURE: {
      return {
        ...state,
        fetchImportEnquiriesStatus: undefined,
        isFetchingImportEnquiriesStatus: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
